import React from 'react';
import { Box, Grid } from '@mui/material';
import Header from '../shared/Header/Header';
import ListingSection from './components/ListingSection/ListingSection';
import HelpSection from './components/HelpSection/HelpSection';
import { listPropertyStyles } from './ListProperty.styles';


const ListProperty = () => {
  const styles = listPropertyStyles;

  return (
    <Box sx={styles.container}>
      {/* Header with same padding as home page */}
      <Box sx={styles.headerContainer}>
        <Header />
      </Box>

      {/* 3-column Grid layout */}
      <Grid container sx={styles.gridContainer} spacing={{xs: 2, lg: 4}}>
        {/* Columns 1-2: ListingSection (spans 8 grid units) */}
        <Grid size={{ xs: 12, md: 7.5 }} sx={styles.cardContainer}>
          <ListingSection />
        </Grid>

        {/* Column 3: Help Section (spans 4 grid units) */}
        <Grid size={{ xs: 12, md: 4.5 }} sx={{...styles.cardContainer, position: {xs: 'relative', md: 'sticky'}, top: {xs: 'auto', md: '20px'}}}>
          <HelpSection />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ListProperty;

